jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

Shopify.Products = (function() {

   var config = { 
     howManyToShow: 4,
     howManyToStoreInMemory: 10, 
     wrapperId: 'recently-viewed-products', 
     templateId: 'recently-viewed-product-template',
     onComplete: null
   };
   
   var productHandleQueue = [];
   var wrapper = null;
   var container = null;
   var shown = 0;

   var cookie = {
     configuration: {
       expires: 90,
       path: '/',
       domain: window.location.hostname
     },
     name: 'shopify_recently_viewed',
     write: function(recentlyViewed) {
       jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
     },
     read: function() {
       var recentlyViewed = [];
       var cookieValue = jQuery.cookie(this.name);
       if (cookieValue !== null) {
         recentlyViewed = cookieValue.split(' ');
       }
       return recentlyViewed;        
     },
     destroy: function() {
       jQuery.cookie(this.name, null, this.configuration);
     },
     remove: function(productHandle) {
       var recentlyViewed = this.read();
       var position = jQuery.inArray(productHandle, recentlyViewed);
       if (position !== -1) {
         recentlyViewed.splice(position, 1);
         this.write(recentlyViewed);
       }       
     }
   };
   
   var finalize = function() {
     new Swiper('#' + config.wrapperId, {
        //loop: true,
        slidesPerView: 2, 
        spaceBetween: 16,
        freeMode: true,
        //loop: true,
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          340: {
              slidesPerView: 2,
              spaceBetween: 16
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 16
          },
          992: {
              slidesPerView: 4,
              spaceBetween: 20
          } 
        },
        on: { 
            init: function () {
                //adjustSliderNagivation();
            },
            afterInit: function (swiper) {
                container.fadeIn(600, function() {
                  adjustSliderNagivation();
                });
            },
            slideChangeTransitionStart: function () {
                
            }
        }, 
    }); 

    function adjustSliderNagivation() {
      let slider = $('#' + config.wrapperId);
      let navPrev = $('.swiper-button-prev', slider);
      let navNext = $('.swiper-button-next', slider);
      let navPosition = false

      let slideImageHeight = $(".swiper-wrapper .swiper-slide:first .product-image-container", slider).outerHeight();
      navPosition = parseFloat(slideImageHeight) / 2 - parseFloat(navPrev.outerHeight() / 2);

      navPrev.css('top', navPosition + 'px')
      navNext.css('top', navPosition + 'px')
    }

    $(window).on('resize', function() {
        adjustSliderNagivation();
    });

     if (config.onComplete) {
       try { config.onComplete() } catch (error) { }
     }  
   };
   
   var moveAlong = function() {
     if (productHandleQueue.length && productHandleQueue !== '' && shown < config.howManyToShow) {
       jQuery.ajax({
         dataType: 'html',
         url: '/products/' + productHandleQueue[0] + '?section_id=product-item-render',
         cache: false,
         success: function(product) {
           var html = $(product).removeAttr('id');
           $('.swiper-wrapper', wrapper).append(html);
           productHandleQueue.shift();
           shown++;
           moveAlong();
         },
         error: function() {
           cookie.remove(productHandleQueue[0]);
           productHandleQueue.shift();
           moveAlong();
         }
       });
     }
     else {
       finalize();
     }
     
   };
   
   return {
    
     resizeImage: function(src, size) {
       if (size == null) {
         return src;
       }

       if (size == 'master') {
         return src.replace(/http(s)?:/, "");
       }

       var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

       if (match != null) {
         var prefix = src.split(match[0]);
         var suffix = match[0];

         return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
       } else {
         return null;
       }
     },

     showRecentlyViewed: function(params) {
        if (jQuery('#' + config.wrapperId).length) {
            var params = params || {};
            jQuery.extend(config, params);
     
            productHandleQueue = cookie.read();
            wrapper = jQuery('#' + config.wrapperId);
            container = wrapper.closest('.recently-viewed-section');
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            if (config.howManyToShow && wrapper.length) {
              moveAlong();    
            }
        }
     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();      
     },
     
     recordRecentlyViewed: function(params) {
       var params = params || {};

       jQuery.extend(config, params);
       var recentlyViewed = cookie.read();

       if (window.location.pathname.indexOf('/products/') !== -1) {
         var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
         var position = jQuery.inArray(productHandle, recentlyViewed);
         if (position === -1) {
           recentlyViewed.unshift(productHandle);
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);              
         }
         cookie.write(recentlyViewed);
       }
     }
   };
 })();